
export class FTStore {
    id: number;
    name: string;
    codeClient: string;
}

export class FTSector {
    sectorId: number;
    sectorName: string;
    stores: FTStore[] = [];
}

export class FTArea {
    areaName: string;
    areaId: number;
    sectors: FTSector[] = [];
}

export class FieldTeam {
    fieldTeamId: number;
    fieldTeamName: string;
    customerBu: number;
    areas: FTArea[] = [];

    static AsFieldTeam(src: FieldTeam): FieldTeam {
        let ft = new FieldTeam();
        ft.fieldTeamId = src.fieldTeamId;
        ft.fieldTeamName = src.fieldTeamName;
        ft.customerBu = src.customerBu;
        ft.areas = src.areas;
        return ft;
    }
}

export class FieldTeamStoreUniverse {

    fieldTeamStoreUniveses: FieldTeam[] = [];

    static FromApi(src: FieldTeamStoreUniverse): FieldTeamStoreUniverse {
        let ftsu = new FieldTeamStoreUniverse();
        if (src.fieldTeamStoreUniveses != null) {
            for (const e of src.fieldTeamStoreUniveses) {
                ftsu.fieldTeamStoreUniveses.push(FieldTeam.AsFieldTeam(e))
            }
        }
        return ftsu;
    }

    findAreas(): FTArea[] {
        const areas: FTArea[] = [];
        if (this.fieldTeamStoreUniveses != null) {
            this.fieldTeamStoreUniveses.forEach(ft => {
                if (ft.areas != null){
                    ft.areas.forEach(a => areas.push(a));
                }
            });
        }
        return areas;
    }

    findSectors(currentAreaId: number) {
        if (this.fieldTeamStoreUniveses != null) {
            for (const ft of this.fieldTeamStoreUniveses) {
                if (ft.areas != null){
                    for (const e of ft.areas) {
                        if (currentAreaId == e.areaId) {
                            return e.sectors;
                        }
                    }
                }
            }
        }
        return [];
    }
}
